<script setup lang="ts">
/**
 * A failure shown inline on the surface that failed, with a clear button (DET-WORK-039: no toasts).
 * Domain-free, but it carries its own i18n string, so it lives in `controls/` rather than `ui/`.
 */
import { X } from 'lucide-vue-next'

defineProps<{ message: string }>()
const emit = defineEmits<{ dismiss: [] }>()
const { t } = useI18n()
</script>

<template>
  <div role="alert" class="px-3 py-2 border-b shrink-0 bg-destructive/10">
    <div class="flex items-start gap-2">
      <p class="flex-1 text-xs text-destructive">{{ message }}</p>
      <button
        type="button"
        class="text-destructive hover:text-destructive/80"
        :title="t('common.clear')"
        :aria-label="t('common.clear')"
        @click="emit('dismiss')"
      >
        <X class="h-3.5 w-3.5" />
      </button>
    </div>
  </div>
</template>
